// styles and images
import { useEffect, useState } from "react";
import { projectStore } from "../../store/Store";
import "./Project.css";

export default function PoTotals() {
  // global
  const projectTotals = projectStore((data) => data.projectTotals);

  // local
  const [poTotals, setPoTotals] = useState([]);
  const [sandExists, setSandExists] = useState(false);
  const [freightPOTotals, setFreightPOTotals] = useState({
    weight: 0,
    cost: 0,
  });
  const [sandPOTotals, setSandPOTotals] = useState({
    weight: 0,
    cost: 0,
  });

  useEffect(() => {
    const tots = [];
    const fTotals = {
      weight: 0,
      cost: 0,
    }
    const sTotals = {
      weight: 0,
      cost: 0,
    }
    if (projectTotals && projectTotals.project_po_totals) {
      projectTotals.project_po_totals.forEach((t) => {
        if (t.vendor !== "Totals") {
          var tot = tots.filter((x) => x.vendor === t.vendor);
          if (tot.length === 0) {
            var newTot = {
              vendor: t.vendor,
              rate: [t.rate],
              sand_po: t.sand_po,
              weight_received: [t.weight_received],
              invoice_amount: [t.invoice_amount],
              total_amount: t.invoice_amount,
              total_weight: t.weight_received,
            };
            tots.push(newTot);
            if (t.sand_po === "") {
              fTotals.weight = fTotals.weight + t.weight_received
              fTotals.cost = fTotals.cost + t.invoice_amount
            } else {
              sTotals.weight = sTotals.weight + t.weight_received
              sTotals.cost = sTotals.cost + t.invoice_amount
            }
          } else {
            tot[0].rate.push(t.rate);
            tot[0].weight_received.push(t.weight_received);
            tot[0].invoice_amount.push(t.invoice_amount);
            tot[0].total_amount = tot[0].total_amount + t.invoice_amount;
            tot[0].total_weight = tot[0].total_weight + t.weight_received;
            if (t.sand_po === "") {
              fTotals.weight = fTotals.weight + t.weight_received
              fTotals.cost = fTotals.cost + t.invoice_amount
            } else {
              sTotals.weight = sTotals.weight + t.weight_received
              sTotals.cost = sTotals.cost + t.invoice_amount
            }
          }
        }
      });
      setFreightPOTotals(fTotals)
      setSandPOTotals(sTotals)
    }
    tots.forEach((t) => {
      t.rate.push("");
      t.weight_received.push(t.total_weight);
      t.invoice_amount.push(t.total_amount);
    });
    setPoTotals(tots);
  }, [projectTotals, setPoTotals]);

  useEffect(() => {
    if (projectTotals && projectTotals.project_po_totals) {
      const idx = projectTotals.project_po_totals.findIndex(
        (x) => x.sand_po !== "",
      );
      if (idx !== -1) {
        setSandExists(true);
      }
    }
  }, [projectTotals, setSandExists]);
  
  return (
    projectTotals &&
    projectTotals.project_po_totals &&
    poTotals && (
      <div className="col">
        <div className="p-2 border text-center project-card">
          {projectTotals && (
            <div className="project-card-list">
              <h5>Freight PO Totals</h5>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>Rate</th>
                    <th>Total Weight (tons)</th>
                    <th>Total Cost $</th>
                  </tr>
                </thead>
                <tbody>
                  {poTotals.map(
                    (t, i) =>
                      t.sand_po === "" &&
                      t.rate.map((r, j) => (
                        <tr key={j}>
                          {j === 0 ? (
                            <td>{t.vendor}</td>
                          ) : j === t.rate.length - 1 ? (
                            <td className="td-totals">{`${t.vendor} Totals`}</td>
                          ) : (
                            <td></td>
                          )}
                          <td>{t.rate[j]}</td>
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.weight_received[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>{t.weight_received[j].toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.invoice_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>{t.invoice_amount[j].toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                          )}
                        </tr>
                      )),
                  )}
                  <tr key="freight_totals">
                    <td className="td-totals-xl">Freight Totals</td>
                    <td></td>
                    <td className="td-totals-xl">{freightPOTotals.weight.toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                    <td className="td-totals-xl">{freightPOTotals.cost.toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {projectTotals && sandExists && (
            <div className="project-card-list">
              <h5>Sand PO Totals</h5>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>PO Number</th>
                    <th>Rate</th>
                    <th>Total Weight (tons)</th>
                    <th>Total Cost</th>
                  </tr>
                </thead>
                <tbody>
                  {poTotals.map(
                    (t, i) =>
                      t.sand_po !== "" &&
                      t.rate.map((r, j) => (
                        <tr key={j}>
                          {j === 0 ? (
                            <td>{t.vendor}</td>
                          ) : j === t.rate.length - 1 ? (
                            <td className="td-totals">{`${t.vendor} Totals`}</td>
                          ) : (
                            <td></td>
                          )}
                          {j === 0 ? <td>{t.sand_po}</td> : <td></td>}
                          <td>{t.rate[j]}</td>
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.weight_received[j].toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>{t.weight_received[j]}</td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.invoice_amount[j].toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>{t.invoice_amount[j]}</td>
                          )}
                        </tr>
                      )),
                  )}
                  <tr key="sand_totals">
                    <td className="td-totals-xl">Freight Totals</td>
                    <td></td>
                    <td></td>
                    <td className="td-totals-xl">{sandPOTotals.weight.toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                    <td className="td-totals-xl">{sandPOTotals.cost.toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    )
  );
}
